/** @format */

import React, { useEffect, useState } from "react";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import WidthNormalIcon from "@mui/icons-material/WidthNormal";
import HeightIcon from "@mui/icons-material/Height";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import FontSizeHover from "../../Pdf-Utils/Tools/FontSizeHover";
import FontSpacingHover from "../FontSpacingHover";
import Tooltip from "@mui/material/Tooltip";
import BoxHeight from "../BoxHeight";
import BoxWidth from "../BoxWidth";
import PanToolIcon from "@mui/icons-material/PanTool";
import { handleDragToggleButton } from "../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import FontSizeHoverCustomBox from "../../Pdf-Utils/Tools/FontSizeHoverCustomBox"; 
import { modifiedCoordinateFunc } from "../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";
function ToolBar({
  settedFontSize,
  settedFontSpace,
  settedBoxHeight,
  settedBoxWidth,
  currVariable,
  coordinate,
  setSelectedBoxId,
}) {
  const dispatch = useDispatch();
  const { eraseToggleButton } = useSelector((state) => state.toolsModification);
  const { coordinates } = useSelector((state) => state.pdfCoordinates);
  const [showHideBox, setShowHideBox] = useState({
    fontSizeBox: false,
    fontSpaceBox: false,
    boxHeightBox: false,
    boxWidthBox: false,
  });
  useEffect(() => {
    console.log("current variable in toolbar is...........", currVariable);
  }, [currVariable]);
  const toggleBox = (boxName) => {
    setShowHideBox((prevState) => {
      const newState = {
        fontSizeBox: false,
        fontSpaceBox: false,
        boxHeightBox: false,
        boxWidthBox: false,
      };
      newState[boxName] = !prevState[boxName];
      return newState;
    });
  };

  const [enableDraggingInput, setEnableDraggingInput] = useState(false);

  const handleDragToggle = () => {
    setEnableDraggingInput((prev) => {
      const newEnableDraggingText = !prev;
      dispatch(handleDragToggleButton(newEnableDraggingText));
      return newEnableDraggingText;
    });
  };

  useEffect(() => {
    setEnableDraggingInput(eraseToggleButton);
  }, [eraseToggleButton]);

  const findRemovedCoord = (id) => {
    const removedCoord = coordinates.find((item) => item.id === id);
    if (removedCoord) {
      dispatch(modifiedCoordinateFunc({ ...removedCoord, action: "removed" }));
    }
  };

  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
    findRemovedCoord(id);
    // dispatch()
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "-40px" }}>
        {showHideBox.fontSizeBox && (
          // <FontSizeHoverCustomBox settedFontSize={settedFontSize} />
          <FontSizeHover settedFontSize={settedFontSize} />
        )}
        {showHideBox.fontSpaceBox && <FontSpacingHover />}
        {showHideBox.boxHeightBox && (
          <BoxHeight settedBoxHeight={settedBoxHeight} />
        )}
        {showHideBox.boxWidthBox && (
          <BoxWidth settedBoxWidth={settedBoxWidth} />
        )}
      </div>
      <div
        style={{
          display: "flex",
          border: "1px solid #1976d2",
          background: "#fff",
          borderRadius: "5px",
          height: "38px",
          boxShadow: "0 0 10px 1px #1976d2",
          alignItems: "center",
        }}
      >
        <Tooltip title={`Drag`} placement='bottom'>
          <PanToolIcon
            // onClick={() => handleDragToggle()}
            onClick={() => setSelectedBoxId(null)}
            sx={{
              borderRadius: enableDraggingInput ? "5px" : "5px",
              color: enableDraggingInput ? "#fff" : "#1976d2",
              padding: "7px",
              background: enableDraggingInput ? "#1976d2" : "white",
              // fontSize:'2rem !important'
            }}
            // fontSize="large"
          />
        </Tooltip>
        {coordinate?.data_type === "text" && (
          // {currVariable?.data_type === "text"  && (
          <>
            <div
              style={{ width: "1px", height: "100%", background: "#1976d2" }}
            ></div>
            <Tooltip title={`Font Size`} placement='bottom'>
              <TextFieldsIcon
                onClick={() => toggleBox("fontSizeBox")}
                sx={{
                  borderRadius: showHideBox?.fontSizeBox ? "5px" : "5px",
                  color: showHideBox?.fontSizeBox ? "#fff" : "#1976d2",
                  padding: "7px",
                  background: showHideBox?.fontSizeBox ? "#1976d2" : "white",
                  // fontSize:'2rem !important'
                }}
                // fontSize="large"
              />
            </Tooltip>
            <div
              style={{ width: "1px", height: "100%", background: "#1976d2" }}
            ></div>
            <Tooltip title={`Letter Spacing`} placement='bottom'>
              <WidthNormalIcon
                onClick={() => toggleBox("fontSpaceBox")}
                sx={{
                  borderRadius: showHideBox?.fontSpaceBox ? "5px" : "5px",
                  color: showHideBox?.fontSpaceBox ? "#fff" : "#1976d2",
                  padding: "7px",
                  background: showHideBox?.fontSpaceBox ? "#1976d2" : "white",
                  // fontSize:'2rem !important'
                }}
                // fontSize="large"
              />
            </Tooltip>
            <div
              style={{ width: "1px", height: "100%", background: "#1976d2" }}
            ></div>
            <Tooltip title={`Box Height`} placement='bottom'>
              <HeightIcon
                onClick={() => toggleBox("boxHeightBox")}
                style={{
                  borderRadius: showHideBox?.boxHeightBox ? "5px" : "5px",
                  color: showHideBox?.boxHeightBox ? "#fff" : "#1976d2",
                  padding: "7px",
                  background: showHideBox?.boxHeightBox ? "#1976d2" : "white",
                  // fontSize:'2rem !important'
                }}
                // fontSize="large"
              />
            </Tooltip>
            <div
              style={{ width: "1px", height: "100%", background: "#1976d2" }}
            ></div>
            <Tooltip title={`Box Width`} placement='bottom'>
              <MultipleStopIcon
                onClick={() => toggleBox("boxWidthBox")}
                sx={{
                  borderRadius: showHideBox?.boxWidthBox ? "5px" : "5px",
                  color: showHideBox?.boxWidthBox ? "#fff" : "#1976d2",
                  padding: "7px",
                  background: showHideBox?.boxWidthBox ? "#1976d2" : "white",
                  // fontSize:'2rem !important'
                }}
                // fontSize="large"
              />
            </Tooltip>
          </>
        )}
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Delete Box********* */}
        <Tooltip title={`Delete`} placement='bottom'>
          <DeleteIcon
            onClick={() =>
              handleDeleteVariable(coordinate?.id || coordinate?.variable)
            }
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default ToolBar;
